import config from '../config';
import { requestWx3rd } from '../utils/request';

const wx3rdDomain = `${config.host}${config.apiRouter.wx3rd}`;

const api = {
  check_login (data, params) {
    return requestWx3rd({
      method: 'GET',
      url: `${wx3rdDomain}/open?projectpath=\\checklogin`,
      data,
      params: params,
    });
  },

  modifyDomain (data, params) {
    return requestWx3rd({
      url: `${wx3rdDomain}/ModifyDomain`,
      method: 'POST',
      data,
      params,
    });
  },

  setWebViewDomain (data, params) {
    return requestWx3rd({
      url: `${wx3rdDomain}/SetWebViewDomain`,
      method: 'POST',
      data,
      params,
    });
  },

  // MemberAuth
  getMemberList (data, params) {
    return requestWx3rd({
      url: `${wx3rdDomain}/MemberAuth`,
      method: 'POST',
      data,
      params,
    });
  },

  // BindTester
  bindTester (data, params) {
    return requestWx3rd({
      url: `${wx3rdDomain}/BindTester`,
      method: 'POST',
      data,
      params,
    });
  },

  // UnbindTester
  unbindTester (data, params) {
    return requestWx3rd({
      url: `${wx3rdDomain}/UnBindTester`,
      method: 'POST',
      data,
      params,
    });
  },

  get_template_draft_list (data) {
    return requestWx3rd.post(`${wx3rdDomain}/GetTemplateDraftList`, {
      ...data,
      projectAppid: undefined,
    }, {
      params: {
        appid: data.projectAppid,
      },
    });
  },

  add_to_template (data) {
    return requestWx3rd.post(`${wx3rdDomain}/AddToTemplate`, {
      ...data,
      projectAppid: undefined,
    }, {
      params: {
        appid: data.projectAppid,
      },
    });
  },

  delete_template (data) {
    return requestWx3rd.post(`${wx3rdDomain}/DeleteTemplate`, {
      ...data,
      projectAppid: undefined,
    }, {
      params: {
        appid: data.projectAppid,
      },
    });
  },

  get_template_list (data) {
    console.log('___get_template_list', data);
    return requestWx3rd.get(`${wx3rdDomain}/GetTemplateList`, {
      params: {
        appid: data.projectAppid,
      },
    });
  },

  commit_template (data) {
    return requestWx3rd.post(`${wx3rdDomain}/CommitTemplate`, {
      ...data,
      projectAppid: undefined,
    }, {
      params: {
        appid: data.projectAppid,
      },
    });
  },

  submit_audit (data) {
    return requestWx3rd.post(`${wx3rdDomain}/SubmitAudit`, {
      ...data,
      projectAppid: undefined,
    }, {
      params: {
        appid: data.projectAppid,
      },
    });
  },

  undo_code_audit (data) {
    return requestWx3rd.post(`${wx3rdDomain}/UndoCodeAudit`, {
      ...data,
      projectAppid: undefined,
    }, {
      params: {
        appid: data.projectAppid,
      },
    });
  },

  get_audit_status (data, params) {
    return requestWx3rd.post(`${wx3rdDomain}/GetAuditStatus`, {
      ...data,
    }, {
      params: params,
    });
  },

  get_latest_auditstatus (data) {
    return requestWx3rd.get(`${wx3rdDomain}/GetLatestAuditStatus`, {
      params: {
        appid: data.projectAppid,
      },
    });
  },

  getCategory (params) {
    return requestWx3rd.get(`${wx3rdDomain}/GetCategory`, {
      params,
    });
  },

  getPage (params) {
    return requestWx3rd({
      url: `${wx3rdDomain}/GetPage`,
      method: 'GET',
      params,
    });
  },

  get_qrcode (data) {
    return requestWx3rd.get(`${wx3rdDomain}/GetQRCode`, {
      params: {
        appid: data.projectAppid,
      },
    });
  },

  // v2.0
  getLatestAuditStatus (params) {
    return requestWx3rd({
      method: 'GET',
      url: `${wx3rdDomain}/GetLatestAuditStatus`,
      params,
    });
  },
};
export default api;
